import React from 'react';
import './content.scss';

export default ({ children, fullwidth, textblock }) => (
  <main className={`content ${fullwidth ? 'fullwidth' : ''} ${textblock ? 'textblock' : ''}`.replace(/\s+/, ' ').trim()}>
    {children}
  </main>
);
